import React, { useState, useEffect, useRef } from "react";

let autoComplete;

const loadScript = (url, callback) => {
  let script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};

function handleScriptLoad(updateQuery, autoCompleteRef, props) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { types: ["(cities)"], componentRestrictions: { country: "us" } }
  );
  autoComplete.setFields(["address_components", "formatted_address"]);
  autoComplete.addListener("place_changed", () =>
    handlePlaceSelect(updateQuery, props)
    
  );
}

async function handlePlaceSelect(updateQuery, props) {
  const addressObject = autoComplete.getPlace(); 
  let country_code = '';
  
  for (var i = 0; i < addressObject.address_components.length; i++) {
    var addressType = addressObject.address_components[i].types[0];
    if (addressType == "country") {
      country_code = addressObject.address_components[i].short_name;
    }
  }

  
  const query = addressObject.formatted_address;
  updateQuery(query);
  props.onChange(addressObject.formatted_address, country_code);
}



function SearchLocationInput(props) {
 
  const [query, setQuery] = useState(props.value);
  const autoCompleteRef = useRef(null);
  
  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyAzBD9_ThJyZrFU9gUR6r__Z-9BeSKpWd4&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef, props)
    );
  }, []);

  return (
    <div className="search-location-input">
      <input
        ref={autoCompleteRef}
        onChange={event => setQuery(event.target.value)}
        placeholder="Enter Location"
        //value={props.value}
        className="form-control"
        defaultValue={props.value}
      />
    </div>
  );
}

export default SearchLocationInput;


// WEBPACK FOOTER //
// ./src/components/admin/writers/GoogleMapLocation.js